export default __webpack_public_path__ + "static/1.7.6/media/europeanUnion.af98b549.svg";